import { useState } from 'react';
import SectionTitle from '@/components/base/SectionTitle';
import { faqs } from '@/mocks/incidents';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          label="常见问题"
          title="读者最常问的几件事"
          desc="关于内容来源、隐私处理与求助方式，这里集中作答。"
          align="center"
        />

        <div className="mx-auto mt-8 max-w-3xl">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className="border-b border-background-200">
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-start justify-between gap-4 py-5 text-left transition-colors hover:text-primary-700"
                >
                  <span className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-sm bg-primary-50 font-heading text-[11px] font-bold text-primary-700">
                      Q
                    </span>
                    <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">{item.q}</span>
                  </span>
                  <i
                    className={`mt-1 shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    } ri-arrow-down-s-line`}
                  ></i>
                </button>
                <div
                  className={`grid overflow-hidden transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="pb-5 pl-8 pr-8 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}